import {useMutation} from '@apollo/react-hooks';

import type {SummaryType} from 'nutshell-graphql-types';
import type {
    EntitySummaryDeleteInput,
    GetEntitySummary as GetEntitySummaryQuery,
    DeleteEntitySummary as DeleteEntitySummaryMutation,
    DeleteEntitySummaryVariables as DeleteEntitySummaryMutationVariables,
} from 'nutshell-graphql-types';

import DELETE_ENTITY_SUMMARY from '../mutations/delete-entity-summary.graphql';
import GET_ENTITY_SUMMARY from '../queries/get-entity-summary.graphql';

export function useDeleteEntitySummary(
    entityId: string,
    summaryType: SummaryType
): (arg1: EntitySummaryDeleteInput) => Promise<any> {
    const [deleteEntitySummary] = useMutation<
        DeleteEntitySummaryMutation,
        DeleteEntitySummaryMutationVariables
    >(DELETE_ENTITY_SUMMARY);

    return (input: EntitySummaryDeleteInput) =>
        deleteEntitySummary({
            variables: {input},
            optimisticResponse: {
                // @ts-expect-error
                __typename: 'Mutation',
                entitySummaryDelete: {
                    __typename: 'EntitySummaryDeletePayload',
                    entitySummary: null,
                },
            },
            update: (proxy, mutationResults) => {
                const cacheResult: GetEntitySummaryQuery | null | undefined = proxy.readQuery({
                    query: GET_ENTITY_SUMMARY,
                    variables: {id: entityId, summaryType},
                });

                const deletedEntitySummary =
                    mutationResults &&
                    mutationResults.data &&
                    mutationResults.data.entitySummaryDelete &&
                    mutationResults.data.entitySummaryDelete.entitySummary;

                if (!deletedEntitySummary) return;

                if (cacheResult) {
                    proxy.writeQuery({
                        query: GET_ENTITY_SUMMARY,
                        variables: {id: entityId, summaryType},
                        data: {
                            entitySummary: null,
                        },
                    });
                }
            },
        });
}
